export enum TipoPessoaEnum {
  Todos = 0,
  Cliente = 1,
  Fornecedor = 2,
  Transportadora = 3,
  Empregado = 4,
  RefProfissional = 5,
  RefPessoal = 6,
  DependentePessoa = 7,
  TitularCheque = 8,
  ContadorEmpresaEmitente = 9,
  EmpresaFilial = 10
}
